/**
 * Converts a date to a string that can be used as a filename.
 * @param date Date to convert.
 * @returns Formatted date string.
 * @example
 * 	const date = new Date();
 * 	const filename = toFilenameDate(date);
 * 	// Output: 2021-08-31_12-00-00
 */
export function toFilenameDate(date?: Date | null): string {
	if (!date) {
		date = new Date();
	}

	return date.toISOString().split('.')[0].replace('T', '_').replace(/:/g, '-');
}
